import { Grid, Skeleton } from '@mui/material';
import React from 'react';
import { Card } from 'reactstrap';

const ListViewSkeleton = ({ listLength, roundSkeletonRequired = true }) => {
  return (
    <>
      {Array.from({ length: listLength }, (v, i) => (
        <div key={i}>
          <Card className="ListViewSkeleton-container">
            <Grid container>
              {roundSkeletonRequired && (
                <Grid item xs={12} sm={12} md={1}>
                  <div className="ListViewSkeleton-first-div-skeleton">
                    <div className="f-skeleton">
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </div>
                    <Skeleton variant="circular"  width={50} height={50} />
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={roundSkeletonRequired ? 11 : 12}>
                <div className="ListViewSkeleton-swcond-div-skeleton">
                  <Skeleton animation="wave" height={30} />
                  <Skeleton animation="wave" />
                </div>
              </Grid>
            </Grid>
          </Card>
        </div>
      ))}
    </>
  );
};

export default ListViewSkeleton;
